<template>
    <div id="group-call-status-box" v-if="visible">
        <div class="closeButton" @click="$emit('close')">  
            <b-icon icon="x-square"/>       
        </div>
         <div class="clearButton" :class="groupButtonCss" @click="clearParticipants">  
            <b-icon icon="telephone-x" v-b-tooltip.hover :title="$t('voip.group_call.remove_all')"/>       
        </div>
        <div class="participants">
            <div  v-for="participant in participants" :key="participant"> <GroupCallParticipant :sipClientId="participant" /></div>
        </div>
    </div>
</template>

<script>
import phone from '@/store/dispatching/phone';
import GroupCallParticipant from '@/components/Dispatching/VoIP/GroupCallParticipant'

export default {
    name: 'GroupCallStatus',
    components: { GroupCallParticipant },
    props: {
        visible: { default: false }
    },
    beforeCreate: function() {
        if (!this.$store.state.phone) {
            this.$store.registerModule('phone', phone);
        }
    },
    computed: {
        participants() {
            let participants = [];
            if (Array.isArray(this.$store.state.phone.phoneState.recipient)) {
                participants = this.$store.state.phone.phoneState.recipient;
            } else if (this.$store.state.phone.phoneState.recipient.length > 0) {
                participants.push(this.$store.state.phone.phoneState.recipient);
            }
            return participants;
        },
        callStatus() {
            return this.$store.state.phone.phoneState.status
        },
        groupButtonCss() {
            if( this.callStatus == "call_connected" || this.callStatus == "calling")
                return "groupButtonDisabled"
            return ""
        },
        groupButtonsEnabled() {
            return !(this.callStatus == "call_connected" || this.callStatus == "calling" )
        }
    },
    methods: {
        clearParticipants() {
            if( this.groupButtonsEnabled )
                this.$store.commit('phone/removeAllGroupCallRecipients');
        }
    }
}
</script>

<style scoped lang="scss">
.closeButton {
    position: absolute;
    right: 10px;
    color: white;
}

.clearButton {
    position: absolute;
    left: 10px;
    color: rgb(199, 6, 6);
}

.clearButton.groupButtonDisabled {
    color: grey;
}
.participants {
    padding-top: 0.9em;
}
</style>